import {
  GearFillIcon,
  IconButton,
  PlusIcon,
  Popover,
  PopoverTrigger,
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuItemSeparator,
} from "@tandemdiabetes/sugarmate-react-components"
import {
  useCallback,
  useMemo,
} from "react"

import { useAccountMedicationModalContext } from "src/components/AccountMedicationModal"
import { usePolyglot } from "src/contexts"
import type { AccountMedication } from "src/types"

const polyglotPrefix = "components.entry_modal.medication.popover."

interface Props {
  currentAccountMedication?: AccountMedication;
}

export function AccountMedicationButton(props: Props) {
  const { currentAccountMedication } = props
  const { openAccountMedicationModal } = useAccountMedicationModalContext()

  const polyglot = usePolyglot()

  const onClickCreate = useCallback(
    () => {
      openAccountMedicationModal()
    },
    [openAccountMedicationModal],
  )

  const onClickEdit = useMemo(
    () => !currentAccountMedication
      ? undefined
      : () => {
        openAccountMedicationModal(currentAccountMedication)
      },
    [
      currentAccountMedication,
      openAccountMedicationModal,
    ],
  )

  if (!currentAccountMedication) {
    return (
      <IconButton
        onClick={onClickCreate}
        id="add-med-btn"
      >
        <PlusIcon />
      </IconButton>
    )
  }

  return (
    <Popover placement="top-end">
      <PopoverTrigger asChild>
        <IconButton>
          <GearFillIcon />
        </IconButton>
      </PopoverTrigger>
      <PopoverMenu
        aria-label={polyglot.t(`${polyglotPrefix}aria_label`)}
      >
        <PopoverMenuItem
          onClick={onClickEdit}
          disabled={!onClickEdit}
          autoDismiss
        >
          {polyglot.t(
            `${polyglotPrefix}edit_cta`,
            {
              name: currentAccountMedication.med.name,
            },
          )}
        </PopoverMenuItem>
        <PopoverMenuItemSeparator />
        <PopoverMenuItem
          onClick={onClickCreate}
          autoDismiss
        >
          {polyglot.t(`${polyglotPrefix}create_cta`)}
        </PopoverMenuItem>
      </PopoverMenu>
    </Popover>
  )
}
